import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import withFilteredQueryRequest from '../../../common/filter-table/withFilteredRequest';
import { Private_Routes } from '../../../constants';
import { PayrollNoveltyFlowsTable } from '../components/tables/PayrollNoveltyFlowsTable';

export default function PayrollNoveltyFlows() {
    const url = `/dublin/api/v1/approval-flows/search`;

    const PayrollNoveltyFlows = withFilteredQueryRequest(
        url,
        PayrollNoveltyFlowsTable
    );

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row '>
                        <div className='col-12 p-3 py-0'>
                            <Helmet>
                                <title>Flujos de aprobación</title>
                            </Helmet>

                            <Breadcrumb>
                                <Breadcrumb.Item href={Private_Routes.HOME}>
                                    Inicio
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    href={Private_Routes.PAYROLL_NOVELTY_FLOWS.index}
                                >
                                    Flujos de aprobación
                                </Breadcrumb.Item>
                            </Breadcrumb>

                            <Row>
                                <Col sm={12}>
                                    <Card>
                                        <Card.Header>
                                            <div className='d-flex gap-2 justify-content-between align-items-center'>
                                                <h5>Flujos de aprobación</h5>
                                                <Link
                                                    to={
                                                        Private_Routes
                                                            .PAYROLL_NOVELTY_FLOWS
                                                            .create
                                                    }
                                                    className='btn btn-primary d-flex align-items-center gap-2'
                                                >
                                                    <i className='ri-add-line'></i>
                                                    Agregar nuevo flujo
                                                </Link>
                                            </div>
                                        </Card.Header>
                                        <Card.Body className=''>
                                            <PayrollNoveltyFlows />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
